import React, { FC } from 'react';
import styled from 'styled-components';
import AppLink from 'common/AppLink/AppLink';
import { Logo, useTenantAppearance } from 'src/utils/hooks/useTenantAppearance';

interface Props {
  style?: React.CSSProperties;
  className?: string;
}

export const DesktopLogos: FC<React.PropsWithChildren<Props>> = ({ style, className }) => {
  const { label, logoSrc } = useTenantAppearance();

  return (
    <StyledLogoLink url="/" hideTextDecoration style={style} className={className}>
      <Logo src={logoSrc} height={38} />
      {label && (
        <>
          <div className="img-divider" />
          <span>{label}</span>
        </>
      )}
    </StyledLogoLink>
  );
};

const StyledLogoLink = styled(AppLink)`
  display: flex;
  gap: ${({ theme }) => theme.spacingSize.m};
  font-size: ${({ theme }) => theme.font.sizeMedium};
  justify-content: center;
  align-items: center;
  color: inherit !important;
  margin-right: ${({ theme }) => theme.spacingSize.l};
  border-radius: 10px;
  padding: 4px 2px;
  border: 1px solid transparent;

  &&:focus {
    border: 1px solid transparent;
    box-shadow: none;
  }

  &&:focus-visible {
    border: 1px solid ${({ theme }) => theme.colorPrimary};
  }

  &&:hover {
    background-color: ${({ theme }) => theme.colorInverseOnSurface};
  }

  .img-divider {
    display: inline-block;
    width: 2px;
    height: 24px;
    background: ${(e) => e.theme.colorOnBanner};
  }
`;
